<template>
  <div class="onboarding-wizard-stepper-container text-center">
    <div class="indicators">
      <template v-for="(step, index) in steps">
        <span
          :key="index"
          :class="{'active': currentStep >= index}"
        />
      </template>
    </div>
    <p
      v-if="!hidePercentageText"
      :class="{'o-25': quickStartInitiate}"
      class="wizard-title font-outfit-bold"
    >
      {{ currentCompletedPercentage }}% <span class="font-outfit-light ml-1">{{ $t('pages.onBoarding.onboardingCompleted') }}</span>
    </p>
  </div>
</template>

<script>
export default {
  name: 'OnboardingStepper',

  inject: ['getCompletedPercentage', 'getQuickStartInitiate', 'getCurrentCompletedPercentage'],

  props: {
    steps: {
      type: Number,
      required: true
    },

    currentStep: {
      type: Number,
      required: true
    },

    hidePercentageText: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    completedPercentage () {
      return this.getCompletedPercentage()
    },

    currentCompletedPercentage () {
      return this.getCurrentCompletedPercentage()
    },

    quickStartInitiate () {
      return this.getQuickStartInitiate()
    }
  }
}
</script>

<style scoped lang="scss">
.onboarding-wizard-stepper-container {
  .indicators {
    display: flex;
    justify-content: center;
    column-gap: 5px;

    span {
      background-color: #d9d9d9;
      width: 14px;
      height: 14px;
      border-radius: 50%;

      &.active {
        background-color: var(--color-primary);
      }
    }
  }

  .wizard-title {
    margin: 13px 0 25px 0;
    font-size: 18px;
  }
}
</style>
